import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  API,MessagesServices, AuthService, UserService, PlaylistService, SongsService, ES, AlbumsService, RadioService, ArtistService,
  ScrollService, SearchService, LoggingService, TooltipService, ErrorLogService, PaymentsService, HelperService, CartService, MetaService
} from './index';
import { Globals } from '../app.globals';


@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    API,
    AuthService,
    Globals,
    UserService,
    SongsService,
    PlaylistService,
    ES,
    AlbumsService,
    RadioService,
    ArtistService,
    ScrollService,
    SearchService,
    LoggingService,
    TooltipService,
    ErrorLogService,
    PaymentsService,
    HelperService,
    CartService,MessagesServices,
    MetaService
  ],

})
export class ApiModule { }



// WEBPACK FOOTER //
// ./src/app/api/api.module.ts